import {
  EntityList,
  EntityListProps,
  renderEnum,
  renderInvertedYesNoIcon,
} from 'components/EntityList'
import { MailTemplate } from 'gql.generated'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type AdminMailTemplatesListProps = EntityListProps<MailTemplate>

export const AdminMailTemplatesList: React.FunctionComponent<
  AdminMailTemplatesListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('inactive', {
        minWidth: 40,
        maxWidth: 40,
        name: t('field.active.label'),
        onRender: renderInvertedYesNoIcon,
        ungroupable: true,
      }),
      fieldColumn('type', {
        onRender: renderEnum(t, 'mailTemplateType'),
        minWidth: 200,
        getGroupValue: (item) => t(`enum.mailTemplateType.${item.type}`),
        isGrouped: true,
      }),
      fieldColumn('name', { isSorted: true, ungroupable: true }),
      fieldColumn('provingGround', {
        minWidth: 140,
        getGroupValue: (item: MailTemplate) =>
          item.provingGround
            ? item.provingGround.title
            : t('model.mailTemplate.allProvingGrounds'),
        onRender: (item: MailTemplate) => {
          if (item.provingGround) {
            return item.provingGround.title
          } else {
            return t('model.mailTemplate.allProvingGrounds')
          }
        },
      }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
